import React, { useState, useRef } from "react";
import { Box, TextField, Button, Typography, Link, Grid } from "@mui/material";
import { OrLineStyles } from "../../Styles/styles";
import { useLocation, useNavigate } from "react-router-dom";
import { useVerifyCodeMutation } from "../../Redux/apis/ApiSlice";
import { notification } from "antd";

const VerifyCode = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { eventId, userId } = location.state || {};
  const [code, setCode] = useState(Array(8).fill(""));
  const inputRefs = useRef([]);
  const [verifyCode] = useVerifyCodeMutation();

  const handleChange = (index) => (event) => {
    const value = event.target.value;
    if (/^[0-9a-zA-Z]$/.test(value) || value === "") {
      setCode((prevCode) => {
        const newCode = [...prevCode];
        newCode[index] = value;
        return newCode;
      });

      if (value !== "" && index < 7) {
        inputRefs.current[index + 1].focus();
      } else if (value === "" && index > 0) {
        inputRefs.current[index - 1].focus();
      }
    }
  };

  const handleKeyDown = (index) => (event) => {
    if (event.key === "Backspace" && code[index] === "" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  // New handlePaste function to auto-fill all inputs on paste
  const handlePaste = (event) => {
    const pasteData = event.clipboardData.getData("Text");
    if (/^[0-9a-zA-Z]{8}$/.test(pasteData)) {
      const codeArray = pasteData.split("");
      setCode(codeArray);
      codeArray.forEach((char, i) => {
        if (inputRefs.current[i]) {
          inputRefs.current[i].value = char;
        }
      });
      inputRefs.current[7]?.focus(); // Focus the last box after paste
    }
    else{
      notification.warning({message: "Please paste complete 8 digit code!"})
    }
  };

  const handleSubmit = async () => {
    const codeString = code.join("");
    if (codeString.length !== 8) {
      notification.warning({message: "Please enter the full 8-digit code!"})
      return;
    }
    const codeInteger = parseInt(codeString, 10);
    try {
      const response = await verifyCode({
        code: codeInteger,
        eventId: Number(eventId),
        userId: Number(userId),
      }).unwrap();

      navigate(`/ticket-information`, { state: { booking: response } });
    } catch (err) {
      console.error("Verification failed:", err);
      notification.error({message: err?.data?.error || "Failed to verify the code! Please retry."})
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="75vh"
    >
      <Box
        sx={{
          padding: "20px",
          borderRadius: "10px",
          boxShadow: 3,
          textAlign: "center",
        }}
      >
        <Typography sx={{ textAlign: "left" }} variant="h6" gutterBottom>
          Alphanumeric Code
        </Typography>
        <Typography variant="h4" gutterBottom>
          Verify Code
        </Typography>
        <Typography variant="body2" gutterBottom>
          Enter the 8-digit alphanumeric code here
        </Typography>
        <Grid container spacing={1} justifyContent="center" mt={2} mb={2}>
          {code.map((char, index) => (
            <Grid item key={index}>
              <TextField
                required
                inputRef={(el) => (inputRefs.current[index] = el)}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#F3F8FF",
                    "& fieldset": {
                      borderColor: "white",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#3f51b5",
                    },
                  },
                  input: {
                    width: {xs:"20px", md:"40px"},
                    height: {xs:"20px", md:"40px"},
                    fontSize: "20px",
                    textAlign: "center",
                    color: "black",
                    border: "2px solid #E1E1E1",
                    borderRadius: "12px",
                  },
                }}
                inputProps={{
                  maxLength: 1,
                }}
                value={char}
                onChange={handleChange(index)}
                onKeyDown={handleKeyDown(index)}
                onPaste={index === 0 ? handlePaste : null} // Attach paste handler only to the first input
              />
            </Grid>
          ))}
        </Grid>
        <Button
          variant="outlined"
          sx={{
            width: "60%",
            backgroundColor: "#061F44",
            borderRadius: 20,
            color: "white",
            "&:hover": {
              color: "grey",
            },
          }}
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </Box>
      <Box sx={OrLineStyles.OrBox}>
        <hr style={OrLineStyles.Line} />
        <Typography sx={OrLineStyles.OrText}>or</Typography>
        <hr style={OrLineStyles.Line} />
      </Box>
      <Button onClick={() => navigate("/QRCode-Upload",{ state: { eventId, userId } })}>
        {/* <Link href="#" variant="body2"> */}
          Link with QR Code instead
        {/* </Link> */}
      </Button>
    </Box>
  );
};

export default VerifyCode;
